var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useReport } from '@tencent/dz-report';
import { useMessageModel } from '../../../hooks';
import { ReplyType } from '../../../const';
export var useReportService = function () {
    var report = useReport();
    var messageModel = useMessageModel();
    var _a = messageModel.inputMessageSource, payload = _a.payload, module = _a.module;
    var sendBtnClick = function () {
        if (!payload || payload.reply_content === '')
            return;
        switch (payload.reply_type) {
            case ReplyType.guess:
                report.click(__assign(__assign({}, module), { element_chinese_type: '猜你想问_聊天框发送', element_id: payload.reply_content, element_type: 'send', element_content: messageModel.inputMessage }));
                break;
            case ReplyType.consult:
                report.click(__assign(__assign({}, module), { element_chinese_type: '咨询按钮_聊天框发送', element_id: payload.reply_content, element_type: 'consult_send', element_content: messageModel.inputMessage }));
                break;
            case ReplyType.retain:
                report.click(__assign(__assign({}, module), { element_chinese_type: '挽留弹窗_聊天框发送', element_id: payload.reply_content, element_type: 'send', element_content: messageModel.inputMessage }));
                break;
            case ReplyType.search:
                report.click(__assign(__assign({}, module), { element_chinese_type: '预输入卡片_聊天框发送', element_id: payload.reply_content, element_type: 'chat_box_send', element_content: messageModel.inputMessage }));
                break;
            default:
                break;
        }
        messageModel.updateInputMessageSource({
            module: module,
            payload: {
                reply_type: '',
                reply_content: '',
            },
        });
    };
    return { sendBtnClick: sendBtnClick };
};
